'use strict';

import { trapFocus, returnFocus } from "./utils/focus";
import { isEscape } from "./utils/escape";

export default class Menu {
    constructor(el) {
        this.button = el;
        this.controlsId = this.button.getAttribute("aria-controls");
        this.content = document.getElementById(this.controlsId);

        this.open = this.button.getAttribute("aria-expanded") === "true";

        this.button.addEventListener('click', this.onButtonClick.bind(this));

        document.addEventListener('keyup', this.onKeyUp.bind(this));
        document.body.addEventListener('click', this.onBodyClick.bind(this));
    }

    onButtonClick(event) {
        event.stopPropagation();
        this.toggle(!this.open);
    }

    enableChoices() {
        // buttons may not exist on load, so query for them each time
        this.content.querySelectorAll('.menu-option').forEach(el => {
            el.setAttribute("tabindex", 0);
        })
    }

    disableChoices() {
        // buttons may not exist on load, so query for them each time
        this.content.querySelectorAll('.menu-option').forEach(el => {
            el.setAttribute("tabindex", -1);
        })
    }

    toggle(open) {
        this.open = open;
        this.button.setAttribute("aria-expanded", `${open}`);
        if (open) {
            this.enableChoices();
            window.returnFocusTo = this.button;
            trapFocus(this.controlsId);
        } else {
            this.disableChoices();
            returnFocus();
        }
    }

    onKeyUp(event) {
        if (isEscape(event)) {
            this.toggle(false);
        }
    }

    onBodyClick() {
        this.toggle(false);
    }
}
